// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__FUrjw","image":"style_image__1SRbb","name":"style_name___hinA"};